import api from "./axios";

export const planlist = async ({ queryKey }) => {
  const [_key, params] = queryKey;
  const response = await api.get("/subscriptions/plans/plan-list", {
    params,
  });
  return response.data;
};

export const myplans = async () => {
  const response = await api.get("/subscriptions/plans/user-plans");
  return response.data;
};

export const addons = async (params = {}) => {
  const response = await api.get("/subscriptions/plans/add-ons", { params });
  return response.data;
};

export const createPayment = async (payload) => {
  const response = await api.post("/payments/create-payment/", payload);

  return response.data.data;
};

export const paymentCallback = async (txnid, coupon_id) => {
  const response = await api.get(`/payments/payu/callback/`, {
    params: {
      txnid,
      ...(coupon_id ? { coupon_id } : {}),
    },
  });
  return response.data?.data;
};

export const paymentStatus = async (payload) => {
  const response = await api.post("/payments/payu/payment-status/", payload);

  return response.data.data;
};

export const couponApply = async (payload) => {
  const response = await api.post("/subscriptions/user-coupon-apply/", payload);

  return response.data;
};

export const featuresList = async (plan_type) => {
  const response = await api.get("/subscriptions/plans/plan-features", {
    params: { plan_type },
  });

  return response.data?.data;
};
